export default __webpack_public_path__ + "static/media/a009-ransomware-03.9471fe9f.svg";